const selector = ".wp-block-steam-blocks-categories-chips";
const root = document.querySelector(selector);
const buttons = root.querySelectorAll("button");

buttons.forEach((button) => {
	button.addEventListener("click", () => {
		buttons.forEach((button) => {
			button.classList.remove("active");
		});

		button.classList.add("active");

		const categoryID = button.dataset.categoryId;
		const base = window.location.href.split("?").at(0);

		if (categoryID) {
			const url = `${base}?category_id=${categoryID}`;
			window.history.replaceState(history.state, "", url);
		} else {
			window.history.replaceState(history.state, "", base);
		}

		window.dispatchEvent(new Event("params_update"));
	});
});
